import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { toast } from "react-toastify";

const CropDialog = ({
  cropDialog,
  setCropDialog,
  setBase64Image,
  setImagePreview,
}) => {
  const { crop, open, imageSrc } = cropDialog;
  const [imageRef, setImageRef] = useState(null);

  const onCropChange = (newCrop) => {
    setCropDialog((prev) => ({ ...prev, crop: newCrop }));
  };

  const onImageLoaded = (image) => {
    setImageRef(image);
  };

  const checkAspectRatio = () => {
    if (!crop.width || !crop.height) return false;
    const aspectRatio = crop.width / crop.height;
    return aspectRatio >= 2 / 3;
  };

  const getCroppedImage = () => {
    console.log("Crop button clicked");
    console.log("Crop values:", crop);
    console.log("imageRef:", imageRef);

    if (!checkAspectRatio()) {
      toast.warning("Aspect ratio must be at least 2:3");
      return;
    }

    if (!imageRef) {
      toast.error("Image failed to load for cropping.");
      return;
    }

    if (!crop.width || !crop.height) {
      toast.error("Invalid crop dimensions.");
      return;
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const scaleX = imageRef.naturalWidth / imageRef.width;
    const scaleY = imageRef.naturalHeight / imageRef.height;

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
      imageRef,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    const base64Image = canvas.toDataURL("image/jpeg");
    console.log("Cropped image generated:", base64Image);

    if (base64Image) {
      setBase64Image(base64Image);
      setImagePreview(base64Image);
      setCropDialog((prev) => ({ ...prev, open: false }));
    } else {
      toast.error("Failed to generate cropped image.");
    }
  };
  const handleImageLoad = (event) => {
    setImageRef(event.target);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setCropDialog((prev) => ({ ...prev, open: false }))}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Crop Image</DialogTitle>
      <DialogContent>
        {imageSrc ? (
          <ReactCrop
            crop={crop}
            onChange={onCropChange}
            onImageLoaded={onImageLoaded}
          >
            <img src={imageSrc} alt="Crop preview" onLoad={handleImageLoad} />
          </ReactCrop>
        ) : (
          <div>Please select an image</div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setCropDialog((prev) => ({ ...prev, open: false }))}
        >
          Cancel
        </Button>
        <Button onClick={getCroppedImage} color="primary">
          Crop & Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CropDialog;
